// extracted by mini-css-extract-plugin
export default {"FooterStyle":"footer_FooterStyle__A33E+","SubheaderLinkStyle":"footer_SubheaderLinkStyle__fHtfJ"};